/* API types */
/* Internal no-shell types. implemented in main pyramid app */
export var EmbeddedType;
(function (EmbeddedType) {
    //Do not change numbers
    EmbeddedType[EmbeddedType["DataDiscovery"] = 3] = "DataDiscovery";
    EmbeddedType[EmbeddedType["Present"] = 8] = "Present";
})(EmbeddedType || (EmbeddedType = {}));
